import ProgressBlockExpandButtonComponent from './progress-block-expand-button.component';
export default ProgressBlockExpandButtonComponent;
